import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SocialSharing = ({ eventDetails, orderNumber }) => {
  const [copied, setCopied] = useState(false);

  const shareText = `Just got my tickets for ${eventDetails?.name}! 🎉 Can't wait for ${eventDetails?.date} at ${eventDetails?.venueName}!`;
  const shareUrl = `${window.location?.origin}/event-detail?id=${eventDetails?.id}`;

  const handleShare = (platform) => {
    let url = '';
    const encodedText = encodeURIComponent(shareText);
    const encodedUrl = encodeURIComponent(shareUrl);

    switch (platform) {
      case 'twitter':
        url = `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`;
        break;
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedText}`;
        break;
      case 'linkedin':
        url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
        break;
      case 'whatsapp':
        url = `https://wa.me/?text=${encodedText} ${encodedUrl}`;
        break;
      default:
        return;
    }

    window.open(url, '_blank', 'width=600,height=400');
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard?.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy link:', err);
    }
  };

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: eventDetails?.name,
          text: shareText,
          url: shareUrl,
        });
      } catch (err) {
        console.error('Error sharing:', err);
      }
    }
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 p-6">
      <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
        <Icon name="Share2" size={20} className="mr-2" />
        Share Your Excitement
      </h2>
      <p className="text-muted-foreground mb-6">
        Let your friends know you're going to {eventDetails?.name}!
      </p>
      {/* Native Share (Mobile) */}
      {navigator.share && (
        <div className="mb-4">
          <Button
            variant="default"
            onClick={handleNativeShare}
            iconName="Share"
            iconPosition="left"
            className="w-full"
          >
            Share Event
          </Button>
        </div>
      )}
      {/* Social Media Buttons */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
        <Button
          variant="outline"
          onClick={() => handleShare('twitter')}
          iconName="Twitter"
          iconPosition="left"
          className="text-sm"
        >
          Twitter
        </Button>
        <Button
          variant="outline"
          onClick={() => handleShare('facebook')}
          iconName="Facebook"
          iconPosition="left"
          className="text-sm"
        >
          Facebook
        </Button>
        <Button
          variant="outline"
          onClick={() => handleShare('linkedin')}
          iconName="Linkedin"
          iconPosition="left"
          className="text-sm"
        >
          LinkedIn
        </Button>
        <Button
          variant="outline"
          onClick={() => handleShare('whatsapp')}
          iconName="MessageCircle"
          iconPosition="left"
          className="text-sm"
        >
          WhatsApp
        </Button>
      </div>
      {/* Copy Link */}
      <div className="flex items-center space-x-2">
        <div className="flex-1 bg-muted rounded-md px-3 py-2">
          <p className="text-sm text-muted-foreground truncate">{shareUrl}</p>
        </div>
        <Button
          variant={copied ? "success" : "outline"}
          onClick={handleCopyLink}
          iconName={copied ? "Check" : "Copy"}
          className="flex-shrink-0"
        >
          {copied ? "Copied!" : "Copy"}
        </Button>
      </div>
    </div>
  );
};

export default SocialSharing;